module.exports = __webpack_public_path__ + "static/assets/667c72a022edc70581e65852f5d95ad8.png";